import { render, staticRenderFns } from "./СargoShip.vue?vue&type=template&id=b7b936ca&"
import script from "./СargoShip.vue?vue&type=script&lang=js&"
export * from "./СargoShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports